import DialChart from "../molecules/DialChart";
import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailSensitive({data, img}) {
    return (
        <MeasurementResult type="민감도" description="민감성 피부는 피부 장벽 기능이 약해져 외부 자극에 쉽게 반응합니다. 신경 섬유가 자극을 받아 발적, 열, 가려움증, 따끔거림, 발진 등의 불편한 증상이 발생하기 쉽습니다. 피부 관리에 있어서 매우 중요한 요소가 되기 때문에 이 항목을 각별히 신경써야 합니다." score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />

                        <div className="caption">화이트 라이트</div>
                    </div>
                    <div className="img-cont">
                        <img src={img.image_red_front} />
                        <img src={img.image_mark_sensitiveness_front} />
                        <div className="caption">레드 라이트</div>
                    </div>
                </div>

                <DegreeSection type="민감도" text={data.degreeText} 
                                badge={data.analysisBadge}
                                items={[
                                    {
                                        value: "저항성 강함",
                                        level: 0
                                    },
                                    {
                                        value: "인내",
                                        level: 1
                                    },
                                    {
                                        value: "보통",
                                        level: 2
                                    },
                                    {
                                        value: "약함",
                                        level: 3
                                    },
                                ]} 
                                level={data.degree}
                                line={3}
                            />

                <section className="flex-content-center">
                    <div className="h4">전체 안면부내 민감부위 점유비율</div>
                    <div className="h-100 d-flex align-items-center">
                        <DialChart value={data.percentage} />
                    </div>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult text={data.aiResult} />
            </div>
        </MeasurementResult>
    )
}